module.exports = __webpack_public_path__ + "img/155633849550acafa5a119e6cdc99aa0.png";